import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/language-switcher';

interface Props {
  children: React.ReactNode
}

export default function AuthLayout({ children }: Props) {
  const { t } = useTranslation();
  return (
    <div className='min-h-svh flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900 lg:max-w-none lg:px-0 relative'>
      {/* Language Switcher in top-right corner */}
      <div className='absolute top-4 right-4 z-10'>
        <LanguageSwitcher variant='outline' size='default' />
      </div>

      <div className='mx-auto w-full sm:w-[480px] px-4 lg:p-8'>
        <div className='mb-6 flex items-center justify-center gap-3'>
          <img src='/images/logo.png' alt={t('appname')} className='h-10 w-auto' />
          <span className='text-xl font-semibold tracking-tight'>
            {t('appname')}
          </span>
        </div>
        {children}
      </div>
    </div>
  )
}
